export default __webpack_public_path__ + "static/media/18 - I Heart PNW.1a75d5fa.jpg";